app
    .filter('yesNo', ['$filter', function ($filter) {
        return function (input) {
            if (typeof input === 'undefined') {
                return '';
            }
            input = parseInt(input * 1);
            return input ? $filter('translate')('oui') : $filter('translate')('non');
        };
    }])

    .filter('typeSite', ['$filter', function ($filter) {
        return function (input) {
            if (typeof input === 'undefined') {
                return '';
            }
            input = parseInt(input * 1);
            return input === 0 ? $filter('translate')('regroup_sites') : (input === 1 ? $filter('translate')('site') : $filter('translate')('lot'));
        };
    }])

    .filter('toBool', function () {
        return function (input) {
            if (typeof input === 'undefined') {
                return false;
            }

            return !!parseInt(input * 1);
        };
    })

    .filter('suivi', ['$sce', '$filter', function ($sce, $filter) {
        var suiviHash = {
            1: {
                slug: 'non_traitee',
                color: '#FFC1C1'
            },
            2: {
                slug: 'en_cours',
                color: '#FFCD9B'
            },
            3: {
                slug: 'traitee',
                color: '#B3FFB3'
            }
        };

        return function (input) {
            if (!input) {
                return '';
            }
            else {
                var data = suiviHash[parseInt(input)];
                if (!data) {
                    return '';
                }
                return $sce.trustAsHtml('<span style="color:' + data.color + '">' + $filter('translate')(data.slug) + '</span>');
            }
        };
    }])

    .filter('delaiLabel', ['$filter', function ($filter) {
        var delaiHash = {
            0: 'optionnel',
            1: 'a_planifier',
            2: 'urgent'
        };

        return function (input) {
            if (!input) {
                return '';
            }
            else {
                var data = delaiHash[parseInt(input)];
                if (!data) {
                    return '';
                }
                return $filter('translate')(data);
            }
        };
    }])

    .filter('countItems', function () {
        return function (value) {
            if (angular.isObject(value)) {
                return Object.keys(value).length;
            }
            if (angular.isArray(value)) {
                return value.length;
            }
            return null;
        };
    })

    .filter('capitalize', function () {
        return function (input) {
            if (!!input && (typeof input === 'string' || input instanceof String)) {
                return input.charAt(0).toUpperCase() + input.substr(1).toLowerCase();
            } else {
                console.log("capitalize error", input);
                return '';
            }
        };
    })

    .filter('orderObjectBy', function () {
        return function (items, field, reverse) {
            var filtered = [];
            angular.forEach(items, function (item) {
                filtered.push(item);
            });
            filtered.sort(function (a, b) {
                return (a[field] > b[field] ? 1 : -1);
            });
            if (reverse) {
                filtered.reverse();
            }
            return filtered;
        };
    })


    /**
     * Vérifie qu'une date est antérieur à aujourd'hui
     * @return {Boolean} reponse
     */
    .filter('isOldDate', function () {
        return function (value) {
            var today = new Date();
            return (value < today);
        };
    })


    /**
     * Filtre qui vérifie si la date n'est pas vide ou si elle est != 000 (pour les milisecondes) avant d'appeler le filtre Angular des dates
     * @type {String}
     */
    .filter('dateFormat', ['$filter', 'localeService', function ($filter, localeService) {
        return function (value, format) {
            var filtered = null;

            if (value && value !== '000') {
                let momentDate = moment(value);

                switch (format) {
                    case 'normal':
                    case 'day' :
                        filtered = momentDate.format('DD/MM/Y');
                        break;
                    case 'week':
                        filtered = momentDate.weeks() + ' ' + momentDate.years();
                        break;
                    case 'month':
                        format = 'MM/yyyy';
                        break;
                    case 'quarter':
                        filtered = $filter('translate')(momentDate.quarter() + '_quarter') + ' ' + momentDate.years();
                        break;
                    case 'semester': {
                        let semester = 1;
                        if (momentDate.quarter() > 2) {
                            semester = 2;
                        }
                        filtered = $filter('translate')(semester + '_semester') + ' ' + momentDate.years();
                        break;
                    }
                    case 'year':
                        format = 'yyyy';
                        break;
                }

                if (filtered === null) {
                    if (localeService.get().locale === 'fr-fr' && format === 'shortDate') {
                        format = 'dd/MM/yyyy';
                    } // 07/03/2017
                    filtered = $filter('date')(value, format);
                }
            }

            return filtered;
        };
    }])

    /**
     * Filtre pour convertire une chaine dd/MM/yyyy en Date string (utile pour le filtre datepicker UI-GRID)
     */
    .filter('dateFrToString', [function () {
        return function (value) {
            if (value == '' || !angular.isDefined(value)) {
                return '';
            }
            var dateArray = value.split("/");
            var dateConverted = new Date(dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0]);
            return (!isNaN(dateConverted.getTime())) ? dateConverted.toString() : '';
        };
    }])


    .filter('returnIfEqualElse', ['$filter', function ($filter) {
        return function (value, termCompare, termToReturn, termToElse, mustBeTranslate) {
            // si la valeur est égale à la valeur comparée, retourne la valeur souhaitée ( traduit si le 3ème param est à true)
            if (value == termCompare) {
                return mustBeTranslate ? $filter('translate')(termToReturn) : termToReturn;
            }
            else if (termToElse != false) {
                return mustBeTranslate ? $filter('translate')(termToElse) : termToElse;
            }

            return value;
        };
    }])


    .filter('objLimitTo', [function () {
        return function (obj, limit) {
            if (!obj) {
                return [];
            }
            var keys = Object.keys(obj);
            if (keys.length < 1) {
                return [];
            }

            var ret = {};
            var count = 0;
            angular.forEach(keys, function (key) {
                if (count >= limit) {
                    return false;
                }
                ret[key] = obj[key];
                count++;
            });

            return ret;
        };
    }])


    .filter('searchOnObj', [function () {
        return function (input, search, property) {
            if (!input || !search || !property) {
                return input;
            }
            var expected = ('' + search).toLowerCase();
            var result = {};
            angular.forEach(input, function (value, key) {
                var actual = ('' + value[property]).toLowerCase();
                if (actual.indexOf(expected) !== -1) {
                    result[key] = value;
                }
            });
            return result;
        };
    }])

    /**
     * Check si la variable est une date, sinon la transforme en date
     */
    .filter('setToValidDate', [function () {
        return function (date) {
            if (!(date instanceof Date)) {
                date = new Date(date);
            }

            return date;
        };
    }])

    /**
     * Check si une date est valide
     */
    .filter('isValidDate', [function() {
        return function (date) {
            return date instanceof Date && !isNaN(date);
        };
    }])

    .filter('isNotEmpty', [function () {
        return function (array) {
            return array.filter(function (element) {
                return element !== null;
            });
        };
    }])

    /**
     * Transforme une chaîne de caractère en slug
     * @param {String} str
     */
    .filter('slugify', [function () {
        return function (str) {
            str = str.replace(/^\s+|\s+$/g, ''); // Trim
            str = str.toLowerCase();

            // Enlève les lettres spéciales
            var from = "àáâãäåąßòóôőõöøďdžèéêëęðçčćìíîïùűúûüľĺłňñńŕšśťÿýžżź";
            var to = "aaaaaaasoooooooddzeeeeeeccciiiiuuuuulllnnnrsstyyzzz";
            for (var i = 0, l = from.length; i < l; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9]/g, ' ') // Remplace les caractères invalides par des espaces
                .replace(/\s+/g, ' ') // Remplace les multiples espaces par un seul espace
                .replace(/^\s+|\s+$/g, '') // Trim
                .replace(/\s+/g, '_') // Remplace les espaces par _
                .replace(/_+/g, '_'); // Remplace les multiples espaces par un seul _

            return str;
        };
    }])

    /**
     * Enleve les espaces
     */
    .filter('removeSpaces', [function() {
        return function(string) {
            if(!angular.isString(string)) {
                return string;
            }
            return string.replace(/[\s]/g, '');
        };
    }])

    .filter('emptyArray', function() {
        return function(array) {
            var filteredArray = [];
            angular.forEach(array, function(item) {
                if(item) filteredArray.push(item);
            });
            return filteredArray;
        };
    })

    /**
     * Vérifie si une valeur se trouve dans un tableau
     * @return {Boolean}
     */
    .filter('inArray', [function () {
        return function (value, array) {
            return array.indexOf(value) !== -1;
        };
    }])

    /**
     * Vérifie si une valeur se trouve dans un tableau
     * @return {Boolean}
     */
    .filter('nl2br', [function () {
        return function (value) {
            return value.replace(/\n/gi, '<br>');
        };
    }])

    .filter('exists', [function() {
        return function (variable) {
            return variable !== null && variable !== undefined;
        };
    }])

    .filter('trustHTML', ['$sce', function ($sce) {
        return function (html) {
            return $sce.trustAsHtml(html);
        };
    }])

    .filter('trustUrl', ['$sce', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }])

    .filter('moment', ['$window', function ($window) {
        return function (date, format) {
            if (!$window || !$window.moment) {
                return date;
            }
            return $window.moment(date).format(format);
        };
    }])

    .filter('join', function () {
        return function join(array, separator, prop) {
            if (!Array.isArray(array)) {
                return array; // if not array return original - can also throw error
            }

            return (!!prop ? array.map(function (item) {
                return item[prop];
            }) : array).join(separator);
        };
    })

    .filter('highlight', ['utilsService', function (utilsService) {
        return function (context, value, min_length) {
            if (!context || !context.length) {
                return '';
            }

            if (!value || !value.length) {
                return context;
            }

            if (angular.isArray(value)) {
                value = angular.copy(value).reduce(function (acc, item) {
                    if (utilsService.isSet(item) && item.length) {
                        acc = acc.concat(item.trim().split(' '))
                    }
                    return acc
                }, []).join(' ');
            }

            if (!value.length) {
                return context;
            }

            min_length = min_length || 2;

            if (/\s/g.test(value)) {
                const initial_value = value;
                value = value.split(' ')
                    .filter((v, i, s) => s.indexOf(v) === i)
                    .filter(v => v.length > min_length);
                value.unshift(initial_value);
                value = value.join('|');
            }

            return context.replace(new RegExp(value, 'gi'), function (match) {
                return `<span class="search__highlight">${match}</span>`;
            });
        }
    }]);
